import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home'; 
import Collection from './Pages/Collection'; 
import CategoriesPage from './Pages/CategoriesPage';
import CategoryName from './Pages/CategoryName';  
import SamplePage from './Pages/SamplePage'; 
import Product from './Pages/Product'; 
import ProductEdits from './Pages/ProductEdits'; 
import EditProductAfterPay from './Pages/EditProductAfterPay';
import EditProductAfterSaved from './Pages/EditProductAfterSaved';
import HelpAndSupport from './Pages/HelpAndSupport';
import Cart from './Pages/Cart';
import PaymentCallback from './Pages/PaymentCallback';
import OrderConfirmation from './Pages/OrderConfirmation';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsCondition from './Pages/TermsCondition';
import ContactUs from './Pages/ContactUs';
import FreeQuote from './Pages/FreeQuote';
import SampleProducts from './Pages/SampleProducts';
import SupplyingArtwork from './Pages/SupplyingArtwork';
import Dashboard from './Pages/Dashboard';
import BespokeRequest from './Pages/BespokeRequest';
import { AuthProvider } from './Components/AuthContext';
import ScrollToTop from './Components/ScrollToTop';
import CookieConsentBanner from './Components/CookieConsentBanner';


function App() {
  return (
    <AuthProvider>
   <Router>
        <ScrollToTop /> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/sample" element={<SamplePage />} />
          <Route path="/product" element={<Product />} />
          <Route path="/ProductEdits" element={<ProductEdits />} />
          <Route path="/EditProductAfterPay" element={<EditProductAfterPay />} />
          <Route path="/EditProductAfterSaved" element={<EditProductAfterSaved />} />
          <Route path="/Help-and-support" element={<HelpAndSupport />} />
          <Route path="/Category-name" element={<CategoryName />} />
          <Route path="/Cart" element={<Cart />} />
          <Route path="/payment/callback" element={<PaymentCallback />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/privac-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/FreeQuote" element={<FreeQuote />} />
          <Route path="/bespoke-request" element={<BespokeRequest />} />
          <Route path="/SampleProducts" element={<SampleProducts />} />
          <Route path="/SupplyingArtwork" element={<SupplyingArtwork />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
        <CookieConsentBanner />
      </Router>
    </AuthProvider>
  );
}

export default App;
